import React from 'react';

/**
 * BrowserFrame — subtle chrome around a mock product screen so it reads as
 * "the app" not "a hero image". Rounded corners, faux traffic-light dots, soft
 * shadow. Content is passed as children so each feature block can slot in its
 * own inline product mockup (KPI cards, invitation card, RSVP form, etc.).
 */
export default function BrowserFrame({ url = 'yourweddingfriends.com', tone = 'light', children, className = '' }) {
  return (
    <div
      className={`rounded-2xl overflow-hidden shadow-2xl border border-[#EFE3D8] bg-white ${className}`}
      style={{ boxShadow: '0 30px 60px -20px rgba(122, 44, 59, 0.25), 0 12px 24px -12px rgba(0,0,0,0.15)' }}
    >
      {/* window chrome */}
      <div className="flex items-center gap-2 px-3 py-2 bg-[#F6EAE0] border-b border-[#EFE3D8]">
        <span className="w-2.5 h-2.5 rounded-full bg-[#E17B7B]" />
        <span className="w-2.5 h-2.5 rounded-full bg-[#E8C267]" />
        <span className="w-2.5 h-2.5 rounded-full bg-[#7DBB7A]" />
        <div className="flex-1 mx-2">
          <div className="mx-auto max-w-xs bg-white/70 rounded-md text-[10px] text-[#9A8A7E] text-center py-0.5 truncate">
            {url}
          </div>
        </div>
      </div>
      <div className={tone === 'dark' ? 'bg-[#2A1F1B]' : 'bg-[#FBF7F2]'}>
        {children}
      </div>
    </div>
  );
}
